import { useState, useEffect, useCallback } from 'react';

const useFilters = () => {


    //  states
    const [movieOptions, setMovieOptions] = useState([]);
    const [selectedMovies, setSelectedMovies] = useState([]);
    const [dimensions, setDimensions] = useState([]);
    const [selectedDimensions, setSelectedDimensions] = useState([]);


    // Load Movies
    useEffect(() => {
        let cancelled = false;
        const loadMovies = async () => {
            try {
                const res = await fetch('/api/movies');
                const data = await res.json();
                console.log(data)
                if (cancelled) return;
                setMovieOptions(
                    data.map(movie => ({
                        id: movie.id,
                        label: movie.title,
                        image: movie.posters.poster,
                        dimensions: movie.dimensions,
                    }))
                );
            } catch (err) {
                console.error("Failed to fetch movies", err);
            }
        }
        loadMovies();
        return () => {
            cancelled = true;
        }
    },[])
  // add / remove handlers
  const addMovie = useCallback((opt) => {
    setSelectedMovies((curr) =>
      curr.includes(opt) ? curr : [...curr, opt]
    );
  }, []);
  const removeMovie = useCallback((id) => {
    setSelectedMovies((curr) => curr.filter((x) => x !== id));
  }, []);

    // load dimensions
    useEffect(() => {
        let cancelled = false;
        const loadDimensions = async () => {
            try {
                const res = await fetch('/api/dimensions');
                const data = await res.json();
                if (cancelled) return;
                const dimOptions = data.map((dim) => ({id: dim, label: dim}))
                setDimensions(dimOptions)
            } catch (err) {
                console.error("Failed to fetch dimensions", err);
            }
        }
        loadDimensions();
        return () => {
            cancelled = true;
        }
    },[])

    const addDimension = useCallback((id) => {
        setSelectedDimensions((curr) =>
            curr.includes(id) ? curr : [...curr, id]
        );
    }, []);
    const removeDimension = useCallback((id) => {
        setSelectedDimensions((curr) => curr.filter((x) => x !== id));
    }, []);
    
    return {
        // movie side
        movieOptions,
        selectedMovies,
        addMovie,
        removeMovie,
        // dimension side
        dimensions,
        selectedDimensions,
        addDimension,
        removeDimension,
    };
}
export default useFilters;